import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import axios from "axios";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import logo from '../login-module/Logo.png';
import "./login.css" // Reusing the same CSS file
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import {StyledInput, StyledPasswordInput} from "./customComponents/styled_input";

const BasicSignup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [usernameHelperMessage, setUsernameHelperMessage] = useState(null);
  const [emailHelperMessage, setEmailHelperMessage] = useState(null);
  const [passwordHelperMessage, setPasswordHelperMessage] = useState(null);

  const surveyorIcon = `${process.env.PUBLIC_URL}/custom-icons/surveyorIcon.png`;
  const illustration = `${process.env.PUBLIC_URL}/custom-icons/login_img.png`;

  const handleInputChange = (type, e) => {
    let value = e.target.value;

    if (type === "email") {
      // Always update the state first
      setEmail(value);
      // Then validate
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) {
        setEmailHelperMessage("Email cannot be empty");
      } else if (!emailRegex.test(value)) {
        setEmailHelperMessage("Please enter a valid email address");
      } else {
        setEmailHelperMessage(null);
      }
    }

    if (type === "password") {
      // Always update the state first
      setPassword(value);
      // Then validate
      if (!value) {
        setPasswordHelperMessage("Password cannot be empty");
      } else if (value.length < 6) {
        setPasswordHelperMessage("Password must be at least 6 characters");
      } else {
        setPasswordHelperMessage(null);
      }
    }
  };

  const [form] = Form.useForm();
  
  const onFinish = async values => {
    let hasErrors = false;

    // Validate all fields
    if (!values.Email) {
      setEmailHelperMessage("Email cannot be empty");
      hasErrors = true;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(values.Email)) {
        setEmailHelperMessage("Please enter a valid email address");
        hasErrors = true;
      } else {
        setEmailHelperMessage(null);
      }
    }

    if (!values.Password) {
      setPasswordHelperMessage("Password cannot be empty");
      hasErrors = true;
    } else if (values.Password.length < 6) {
      setPasswordHelperMessage("Password must be at least 6 characters");
      hasErrors = true;
    } else {
      setPasswordHelperMessage(null);
    }

    // If there are validation errors, don't proceed
    if (hasErrors) {
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post('/auth/signup', {
        email: values.Email,
        password: values.Password
      });

      if (response.data.success) {
        message.success('Account created successfully! Please sign in.');
        setLoading(false);
        navigate('/login');
      } else {
        message.error(response.data.message || 'Signup failed. Please try again.');
        setLoading(false);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      if (err.response?.data?.message) {
        message.error(err.response.data.message);
      } else {
        message.error('Signup failed. Please try again.');
      }
    }
  };

  const handleSignIn = () => {
    navigate('/login');
  };

  return (
    <div className="responsive-login-container">
      {/* <div className="login-illustration">
        <LazyLoadImage alt="Illustration" effect="opacity" src={illustration} />
      </div> */}
      <div className="login-form-container">
        <LazyLoadImage
          src={logo}
          alt="Surveyor's AI"
          className="surveyor-icon"
          effect="opacity"
        />

        <h4 className="signin-text">Create your account</h4>
        
        {/* Main Signup Form Section */}
        <div className="login-form-section">
          <Form
            className="form-data"
            form={form}
            onFinish={onFinish}
            layout="vertical"
          >
            <div className="login-basic">
              {/* <Form.Item
                name="Username"
                help={
                  <span style={{ color: "red" }}>
                    {usernameHelperMessage}
                  </span>
                }
              >
                <div className="email-container">
                  <StyledInput
                    className="login-email"
                    value={username}
                    placeholder="Username"
                    onChange={e => handleInputChange("username", e)}
                  />
                </div>
              </Form.Item> */}

              <Form.Item
                name="Email"
                help={
                  <span style={{ color: "red" }}>
                    {emailHelperMessage}
                  </span>
                }
              >
                <div className="email-container">
                  <StyledInput
                    className="login-email"
                    value={email}
                    placeholder="Email Address"
                    onChange={e => handleInputChange("email", e)}
                  />
                </div>
              </Form.Item>

              <Form.Item
                name="Password"
                help={
                  <span style={{ color: "red" }}>
                    {passwordHelperMessage}
                  </span>
                }
              >
                <div className="password-container">
                  <StyledPasswordInput
                    className="login-pass"
                    value={password}
                    placeholder="Password"
                    onChange={e => handleInputChange("password", e)}
                  />
                </div>
              </Form.Item>

              <Form.Item className="login-btn-container">
                <Button className="login-btn" type="primary" htmlType="submit">
                  Sign Up {loading && <Loading3QuartersOutlined spin />}
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>

        {/* Sign In Section */}
        <div className="signup-section">
          <p className="signup-text">Already have an account?</p>
          <Button className="signup-btn" onClick={handleSignIn}>
            Sign in
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BasicSignup;